import React from "react";
import bgImage from "../../assets/images/modalbg.png"
import { formatPhoneNumber } from "../common/constant/constant";
const ViewModal = ({ isOpen, onClose, title, details }) => {
  if (!isOpen) return null;

  function convertTimestampInitialsOutreach(input) {
    const date = new Date(input);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
}

function calculateAge(dateOfBirth) {
  // Split the input date (DD-MM-YYYY) into parts
  const [day, month, year] = dateOfBirth.split('-').map(Number);
  
  // Create a Date object using the parsed parts
  const birthDate = new Date(year, month - 1, day); // Month is 0-indexed in JavaScript
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();

  // Adjust age if the current month and day are before the birth month and day
  if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
  }

  return age;
}

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 w-full h-full ">
      <div className="bg-white rounded-lg shadow-lg w-[498px]  p-[25px]">
        {/* Header */}
        <div className=" rounded-t-lg relative">
        <img src={bgImage} />
          <h2 className="text-lg font-bold text-gray-700 relative bottom-11 left-5">{title}</h2>
        </div>

        {/* Body */}
        <div className="p-6 pt-0">
          <div className="flex items-center mb-4">
            <div className="w-[64px] h-[64px] bg-purple-200 rounded-full flex items-center justify-center text-lg font-[600] text-[#AC7EBC] text-[21px]">
              {details.firstName.charAt(0)}{details.lastName.charAt(0)}
            </div>
            <div className="ml-4">
              <h3 className="text-[16px] font-[600] text-[#1b2a3d]">{details.firstName} {details.lastName}</h3>
              <p className="text-[16px] font-[400] text-[#010101]">{details.email}</p>
            </div>
          </div>
          <hr className="my-6" />
          <ul className="space-y-[18px] ">
           {details.contact? <li className="text-[#010101] leading-[22px]">
              <span className="font-semibold text-[#010101]">Contact:</span> {formatPhoneNumber(details.contact)}
            </li>:''}
            {details.dob?<li className="text-[#010101] leading-[22px]">
              <span className="font-semibold text-[#010101]">Date of Birth:</span>  {convertTimestampInitialsOutreach(details.dob)}
            </li>:''}
            {details.dob ?<li className="text-[#010101] leading-[22px]">
              <span className="font-semibold text-[#010101]">Age:</span> {calculateAge(convertTimestampInitialsOutreach(details.dob))}
            </li>:''}
            {details.zip?<li className="text-[#010101] leading-[22px]">
              <span className="font-semibold text-[#010101]">Zip Code:</span> {details.zip}
            </li>:''}
          {details.gender?  <li className="text-[#010101] leading-[22px]">
              <span className="font-semibold text-[#010101]">Gender:</span> {details.gender}
            </li>:''}
            <li className="text-[#010101] leading-[22px]">
              <span className="font-semibold text-[#010101]">Source:</span> {details.source}
            </li>
          </ul>
        </div>

        {/* Footer */}
        <div className="p-2 pt-0 flex justify-start">
          <button
            onClick={onClose}
            className="px-5 py-3 bg-[#245CEA] text-white rounded-md hover:bg-blue-600 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewModal;
